/* On-model campaign photos (theme assets look-*.jpg) matched to products.
   Each entry matches a style name and, optionally, a colour; correct any pairing here
   and every page picks it up. */
(() => {
  const DIR = window.PN_ASSETS || '';
  const LOOKS = [
    { style: /neck ?line heavy ?weight/i, colour: /white/i, photos: ['look-necktee-1'] },
    { style: /rm heavy ?weight/i, colour: /dark gr[ae]y|charcoal/i, photos: ['look-rmtee-1', 'look-rmtee-2', 'look-rmtee-3'] },
    { style: /mesh shorts/i, colour: /black/i, photos: ['look-shorts-1', 'look-rmtee-3'] },
    { style: /drop shoulder charcoal tee/i, photos: ['look-charcoal-1'] },
    { style: /drop shoulder khaki tee/i, photos: ['look-khaki-1'] },
    { style: /anytime fitness heavy ?weight/i, colour: /black/i, photos: ['look-aftee-black-1', 'look-aftee-black-2'] },
    { style: /^pullover hoodie af$/i, colour: /^purple/i, photos: ['look-purplehoodie-1', 'look-purplehoodie-2'] },
    { style: /gym bag/i, photos: ['look-gymbag-1', 'look-gymbag-2'] },
    { style: /^(beanie|toque)$/i, photos: ['look-beanie-1'] },
    { style: /mag water bottle/i, colour: /black/i, photos: ['look-bottle-1'] },
  ];
  const forItem = (styleName, colourName) => {
    const hit = LOOKS.find((l) => l.style.test(styleName || '') && (!l.colour || l.colour.test(colourName || '')));
    return hit ? hit.photos.map((p) => `${DIR}${p}.jpg`) : [];
  };
  window.PNLooks = { forItem };
})();
